// Footer.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom"; // استيراد Link من React Router
import logo from "../assets/logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  // روابط الصفحات مع المسارات المناسبة
  const quickLinks = [
    { name: "Home", path: "/", icon: "fa-solid fa-house" },
    { name: "About Us", path: "/about", icon: "fa-solid fa-info-circle" },
    { name: "Services", path: "/services", icon: "fa-solid fa-stethoscope" },
    { name: "Packages", path: "/packages", icon: "fa-solid fa-box" },
    { name: "Portfolio", path: "/portfolio", icon: "fa-solid fa-folder-open" },
    { name: "Contact", path: "/contact", icon: "fa-solid fa-envelope" },
  ];

  const servicesList = [
    "Medical Websites",
    "Hospital Systems",
    "Digital Marketing",
    "Appointment Systems",
    "AI Health Analytics",
    "Telemedicine",
  ];

  const contactInfo = [
    { icon: "fa-solid fa-location-dot", text: "الغردقة، مصر" },
    { icon: "fa-solid fa-phone", text: "+201037334294" },
    { icon: "fa-solid fa-envelope", text: "Support@codicalcompany.com" },
  ];

  const socialLinks = [
    { name: "Facebook", icon: "fa-brands fa-facebook-f", link: "https://www.facebook.com/share/1CTNfFTDf3/", color: "#1877f2" },
    { name: "Instagram", icon: "fa-brands fa-instagram", link: "https://www.instagram.com/codical.company?igsh=MWEycG43bHE1NTByOQ==", color: "#e4405f" },
  ];

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail("");
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="footer" style={{ background: "#dadee9", color: "#000" }}>
      <div className="footer-content" style={{ padding: "2rem" }}>
        <div className="footer-top" style={{ display: "flex", flexWrap: "wrap", gap: "2rem" }}>
          
          {/* Logo Section */}
          <div className="footer-section" style={{ flex: "1 1 240px" }}>
            <Link to="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1rem" }}>
            <div className="logo-icon">
  <img src={logo} alt="CodiCal Logo" />
</div>
              <h2 style={{ fontSize: "1.5rem", margin: 0, color: "#0E74AB" }}>CodiCal</h2>
            </Link>
            <p style={{ fontSize: "0.85rem", color: "#333", lineHeight: 1.5 }}>
              Transforming healthcare through innovative digital solutions.
              We provide cutting-edge medical software and services.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section" style={{ flex: "1 1 150px" }}>
            <h3 style={{ fontWeight: 700, marginBottom: "1rem", color: "#0E74AB" }}>Quick Links</h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {quickLinks.map((link, index) => (
                <li key={index} style={{ marginBottom: "0.5rem" }}>
                  <Link 
                    to={link.path}
                    style={{ textDecoration: "none", color: "#0E74AB", transition: "color 0.3s" }}
                    onMouseEnter={e => e.target.style.color = "#084a6d"}
                    onMouseLeave={e => e.target.style.color = "#0E74AB"}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services - يمكن تحويلها إلى روابط إذا كان لديك صفحات لكل خدمة، حالياً هي مجرد نص */}
          <div className="footer-section" style={{ flex: "1 1 150px" }}>
            <h3 style={{ fontWeight: 700, marginBottom: "1rem", color: "#0E74AB" }}>Our Services</h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {servicesList.map((service, index) => (
                <li key={index} style={{ marginBottom: "0.5rem", color: "#0E74AB" }}>{service}</li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section" style={{ flex: "1 1 200px" }}>
            <h3 style={{ fontWeight: 700, marginBottom: "1rem", color: "#0E74AB" }}>Contact Info</h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {contactInfo.map((info, index) => (
                <li key={index} style={{ marginBottom: "0.5rem", color: "#333" }}>{info.text}</li>
              ))}
            </ul>

            {/* Newsletter */}
            <form onSubmit={handleSubscribe} style={{ marginTop: "1rem", display: "flex", gap: "0.5rem" }}>
              <input
                type="email"
                placeholder="Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{ flex: 1, padding: "0.5rem", border: "1px solid #0E74AB", borderRadius: "4px" }}
              />
              <button 
                type="submit" 
                style={{ padding: "0.5rem 1rem", backgroundColor: "#0E74AB", color: "#fff", border: "none", cursor: "pointer", borderRadius: "4px" }}
                onMouseEnter={e => e.target.style.backgroundColor = "#084a6d"}
                onMouseLeave={e => e.target.style.backgroundColor = "#0E74AB"}
              >
                Subscribe
              </button>
            </form>
            {subscribed && <div style={{ marginTop: "0.5rem", color: "green" }}>Subscribed!</div>}
          </div>
        </div>

        {/* Social Links */}
        <div className="footer-social" style={{ marginTop: "2rem", display: "flex", gap: "1rem" }}>
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "38px",
                height: "38px",
                backgroundColor: social.color,
                color: "#fff",
                borderRadius: "50%",
                textDecoration: "none",
                transition: "opacity 0.3s"
              }}
              onMouseEnter={e => e.target.style.opacity = "0.8"}
              onMouseLeave={e => e.target.style.opacity = "1"}
            >
              <i className={social.icon}></i>
            </a>
          ))}
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom" style={{ marginTop: "2rem", textAlign: "center", fontSize: "0.8rem", color: "#555" }}>
          © {currentYear} CodiCal. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;